import React, { Dispatch, SetStateAction, useState, useRef, useEffect, useMemo } from "react";
import { Mail, BarChart2, AlertTriangle, Wrench, BellRing, Wifi, Plus, Trash2, Clock, CheckCircle2 } from 'lucide-react';
import Select, { GroupBase } from 'react-select';
import Modal from "../../../components/Modal/Modal";
import * as Body from './Styles'
import Input from '../../../components/Input/Input'
import Button from '../../../components/Button/Button'
import * as BodyInput from '../../../components/Input/Style'
import * as Functions from '../../../utils/functions/functions'
import * as Regex from '../../../utils/Regex/Regex'
import axios from 'axios'
import api from '../../../utils/axiosInstance'
import {useNavigate} from 'react-router-dom'
import ListModal from '../../../components/ListModal/ListModal'
import { ToggleSwitch } from '../../../components/ToggleSwitch/ToggleSwitch'
import imageCompression from 'browser-image-compression'
import * as Types from '../../../utils/redux/types'
import { useDispatch } from "react-redux";
import EyeIcon from '../../../assets/icons/eye-regular.svg'
import EyeSplashIcon from '../../../assets/icons/eye-slash-regular.svg'
import Loading from "../../../components/Loading/Loading";
import CodeInput from "../../../components/CodeInput/CodeInput";
import NumberInput from "../../../components/NumberInput/NumberInput";
import Flatpickr from 'react-flatpickr';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import { FP_CALENDAR_THEME, markOtherBound } from '../../../utils/styles/flatpickrTheme';
import 'flatpickr/dist/themes/dark.css';
import { USE_MOCK } from '../../../utils/mock/mockFlag';
import { mockUsinas } from '../../../utils/mock/mockData';
import { requestAndRegisterPush, getPushPermissionStatus } from '../../../utils/pushNotification';
import { getApiBaseUrl } from '../../../utils/defines/apiUrl';
import { useIsMobile } from '../../../utils/hooks/useIsMobile';

const avatar = require('../../../assets/images/avatar-1.png')

type ModalProp = {
    toggle: Dispatch<SetStateAction<boolean>>
}

type AuthTecnicoProps = {
    p_nome: string,
    s_nome: string,
    email: string,
    telefone_ddd: string,
    telefone_numero: string,
    senha: string,    
    toggle: Dispatch<SetStateAction<boolean>>
}

type ModalSelectProp = {
    toggle: Dispatch<SetStateAction<boolean>>,
    setText: Dispatch<SetStateAction<string>>
}

// export const AuthModal: React.FC <ModalProp> = ({
//     toggle, 
// }) => {
//     const navigate = useNavigate()

//     useState(()=>{
//         axios.post(process.env.REACT_APP_AUTH_REQUEST_URL!, {})
//             .then((response)=> {
//                 switch(response.data.code){
//                     case 200:
//                         break
//                     case 403:
//                         alert("Token inválido")
//                         navigate('/')
//                         break
//                     case 500:
//                         alert("Erro interno")
//                         navigate('/')
//                         break
//                 }
//             })
//             .catch((error)=>{
//                 alert("Erro" + error)
//             })
//     })   

//     const [mensagem, setMensagem] = useState("")

//     const [code1, setCode1] = useState("")
//     const [code2, setCode2] = useState("")
//     const [code3, setCode3] = useState("")
//     const [code4, setCode4] = useState("")
//     const [code5, setCode5] = useState("")
//     const [code6, setCode6] = useState("")

//     const ref1 = useRef<any>()
//     const ref2 = useRef<any>()
//     const ref3 = useRef<any>()
//     const ref4 = useRef<any>()
//     const ref5 = useRef<any>()
//     const ref6 = useRef<any>()

//     const field = (text: string, value: number) => {
//         switch(value){
//             case 1:
//                 setCode1(text)
//                 if(text.length > 0) ref2.current.focus()
//                 break
//             case 2:
//                 setCode2(text)
//                 text.length > 0? ref3.current.focus():ref1.current.focus()
//                 break
//             case 3:
//                 setCode3(text)
//                 text.length > 0? ref4.current.focus():ref2.current.focus()
//                 break
//             case 4:
//                 setCode4(text)
//                 text.length > 0? ref5.current.focus():ref3.current.focus()
//                 break
//             case 5:
//                 setCode5(text)
//                 text.length > 0? ref6.current.focus():ref4.current.focus()
//                 break
//             case 6:
//                 setCode6(text)
//                 if(text.length === 0) ref5.current.focus()
//                 break
//         }
//     }

//     const send = () => {
//         setMensagem("")
//         if((code1.length  == 0 ) && (code2.length == 0) && (code3.length == 0) 
//             && (code4.length == 0) && (code5.length == 0) && (code6.length == 0)){
//             setMensagem("Preencha todos os campos")
//             return
//         }

//         let concat = code1.concat(code2, code3, code4, code5, code6)
//         let code = Number(concat)
//         axios.post(process.env.REACT_APP_AUTH_URL!, {code})
//             .then((response)=> {
//                 switch(response.data.code){
//                     case 200:
//                         toggle(false)
//                         break
//                     case 403:
//                         setMensagem("Token/Código inválido")
//                         break
//                     case 500:
//                         alert("Erro interno")
//                         break
//                 }
//             })
//             .catch((error)=> {
//                 alert('Erro: '+ error)
//             })
//     }



//     return <Modal toggleModal={toggle} title="Autenticação" >
//        <Body.Content>
//            <Body.Text>Enviamos um código de confirmação para seu telefone, insira-o para prossegir</Body.Text>
//            <Body.Row>
//                <Body.HalfContent percentage={16}>
//                     <BodyInput.Input ref={ref1} value={code1} onChange={e => field(e.target.value, 1)} 
//                         maxLength={1} align="center"/>
//                </Body.HalfContent>
//                <Body.HalfContent percentage={16}>
//                     <BodyInput.Input ref={ref2} value={code2} onChange={e => field(e.target.value, 2)}  
//                         maxLength={1} align="center"/>
//                </Body.HalfContent>
//                <Body.HalfContent percentage={16}>
//                     <BodyInput.Input ref={ref3} value={code3} onChange={e => field(e.target.value, 3)}  
//                         maxLength={1} align="center"/>
//                </Body.HalfContent>
//                <Body.HalfContent percentage={16}>
//                     <BodyInput.Input ref={ref4} value={code4} onChange={e => field(e.target.value, 4)} 
//                         maxLength={1} align="center"/>
//                </Body.HalfContent>
//                <Body.HalfContent percentage={16}>
//                     <BodyInput.Input ref={ref5} value={code5} onChange={e => field(e.target.value, 5)}  
//                         maxLength={1} align="center"/>
//                </Body.HalfContent>
//                <Body.HalfContent percentage={16}>
//                     <BodyInput.Input ref={ref6} value={code6} onChange={e => field(e.target.value, 6)} 
//                         maxLength={1} align="center"/>
//                </Body.HalfContent>
//            </Body.Row>
//            <Button text="Cadastrar" width={40}/>
//        </Body.Content>
//     </Modal>
// }


export const RegisterUser: React.FC <ModalProp> = ({
    toggle
}) => {
    const [p_nome, setName] = useState("")
    const [s_nome, setSobrenome] = useState("")
    const [email, setEmail] = useState("")
    const [telefone_ddd, setDDD] = useState('')
    const [senha, setSenha] = useState("")
    const [telefone_numero, setTelefone] = useState("")

    const [codigo_tfa, setCode] = useState("")
    
    const [content, toggleContent] = useState("SEND")
    const dispatch = useDispatch()
    const [loading, toggleLoading] = useState(false)

    const [passVisible, toggleVisibility] = useState(true)

    const telefoneInsert = (text: string) => {
        setTelefone(Regex.numberRegex(text, telefone_numero))
    }

    const send = () => {
        toggleLoading(true)
        axios.post(process.env.REACT_APP_TECNICO_CREATE!, 
            {p_nome, s_nome, email, telefone_ddd, telefone_numero, senha},  
            {withCredentials: true})
            .then((response)=>{
                toggleLoading(false)
                toggleContent("INSERT")
            })
            .catch((e)=>{
                toggleLoading(false)
                console.log(e)
            })
    }

    const inputData = () => {
        return <>
        <Body.Row >
               <Body.HalfContent percentage={49}>
                    <Input placeholder="NOME" text={p_nome} setText={setName} />
               </Body.HalfContent>
               <Body.HalfContent percentage={49}>
                    <Input placeholder="SOBRENOME" text={s_nome} setText={setSobrenome} />
               </Body.HalfContent>
            </Body.Row>
            <Input placeholder="EMAIL" text={email} setText={setEmail} />
            <Body.Row >
               <Body.HalfContent percentage={49.5}>
                    <Body.PasswordContent>
                        <Body.Icon src={passVisible?EyeIcon:EyeSplashIcon} 
                                onClick={()=>toggleVisibility(old => !old)}/>
                        <Input placeholder="SENHA" text={senha} setText={setSenha}
                            secret={passVisible} paddingRight={60} />
                    </Body.PasswordContent>
               </Body.HalfContent>
               <Body.HalfContent percentage={49.5}>
                <Body.Row >
                    <Body.HalfContent percentage={30}>
                        <Input placeholder="DDD" text={telefone_ddd} setText={setDDD} 
                            maxLenght={2}/>
                    </Body.HalfContent>
                    <Body.HalfContent percentage={68}>
                        <Input placeholder="Telefone" text={telefone_numero} setText={telefoneInsert} 
                            maxLenght={10}/>
                    </Body.HalfContent>
                    </Body.Row>
               </Body.HalfContent>
            </Body.Row>
            <div style={{marginBottom: 20}} />
           <Button text="Cadastrar" action={send}/></>
    }

     const trySendCode = () => {

        axios.post(process.env.REACT_APP_TECNICO_CREATE!, 
            {p_nome, s_nome, email, telefone_ddd, telefone_numero, senha, codigo_tfa},
            {withCredentials: true})
            .then((response)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: 'Usuário cadastrado com sucesso'})
                toggle(false)
            })
            .catch((error)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: error.response.data})
            })
    }

    const resendCode = () => {
		axios.get(process.env.REACT_APP_RESEND_URL!, {withCredentials: true})
			.then((response) => {	
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: "Código reenviado com sucesso"})	
			})
			.catch((error) => {
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: "Erro ao reenviar código " + error.response.status})
			})
	}


    const insertCode = () => {
        return <>
            <Body.Text>Enviamos um código de autenticação para seu celular, 
                insira-o para prossguir com alteração dos dados</Body.Text>
            <CodeInput setText={setCode} />
            <div style={{marginBottom: 20}} />
            <Body.Row style={{alignItems: 'center', justifyContent: 'center',
                gridGap: '0px 10px'}}>
                <Button text="Continuar" action={trySendCode} />
                <Button text="Reenviar código" action={resendCode} />
            </Body.Row>
        </>
    }

    const getContent = () => {
        switch(content){
            case "SEND": 
                return inputData()
            case "INSERT":
                return insertCode()
        }
    }

    return <>
     <Modal toggleModal={toggle} title="Cadastrar usuário" >
       <Body.Content>
        {getContent()}
       </Body.Content>
    </Modal>
    </>
}

export const ChangeEmail: React.FC <ModalProp> = ({
    toggle, 
}) => {
    const [email, setEmail] = useState('')
    const [content, toggleContent] = useState("SEND")
    const [loading, toggleLoading] = useState(false)

    const [errorEmail, toggleErrorEmail] = useState(false)
    const dispatch = useDispatch()
    const [codigo_tfa, setCode] = useState("")

    const send = () => {
        if(!Functions.verifyEmail(email)){
            toggleErrorEmail(true)
            return
        }
        toggleErrorEmail(false)
        toggleLoading(true)
        axios.put(process.env.REACT_APP_EMAIL_URL!, {email}, {withCredentials: true})
            .then((response)=> {
                toggleContent("INSERT")
                toggleLoading(false)
            })
            .catch((error)=> {
                dispatch({type: 'ADD_NOTIFICATION', status: 2, title: error.response.data.msg})
                toggleLoading(false)
            })
    }

    const insertEmail = () => {
        return <>
            <Input  placeholder="NOVO EMAIL" text={email} 
                setText={setEmail} error={errorEmail} />
            <div style={{marginBottom: 20}} />
            <Button text="Alterar"  action={()=>send()}/>
        </>
    }

     const trySendCode = () => {

        toggleLoading(true)
        axios.put(process.env.REACT_APP_EMAIL_URL!, {email, codigo_tfa},{withCredentials: true})
            .then((response)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: 'Email alterado com sucesso'})
                toggle(false)
                toggleLoading(false)
            })
            .catch((error)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: error.response.data.msg})
                toggleLoading(false)
            })
    }

    const resendCode = () => {
		axios.get(process.env.REACT_APP_RESEND_URL!, {withCredentials: true})
			.then((response) => {	
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: "Código reenviado com sucesso"})	
			})
			.catch((error) => {
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: "Erro ao reenviar código " + error.response.status})
			})
	}


    const insertCode = () => {
        return <>
            <Body.Text>Enviamos um código de autenticação para seu celular, 
                insira-o para prossguir com alteração dos dados</Body.Text>
            <CodeInput setText={setCode} />
            <div style={{marginBottom: 20}} />
            <Body.Row style={{alignItems: 'center', justifyContent: 'center',
                gridGap: '0px 10px'}}>
                <Button text="Continuar" action={trySendCode} />
                <Button text="Reenviar código" action={resendCode} />
            </Body.Row>
        </>
    }


    const getContent = () => {
        switch(content){
            case "SEND":
                return insertEmail()
            case "INSERT":
                return insertCode()
        }
    }

    return <Modal title="Alterar email" toggleModal={toggle}>
        <Body.Content>
            {getContent()}
        {loading?<Loading />:null}
        </Body.Content>
    </Modal>
}

export const ChangePassword: React.FC <ModalProp> = ({
    toggle, 
}) => {
    const [content, toggleContent] = useState("SEND_CODE")

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')
    const dispatch = useDispatch()

    const [passVisible, toggleVisibility] = useState(true)
    const [errorPass, toggleErrorPass] = useState(false)
    const [celular, setCelular] = useState("")
    const [codigo_tfa, setCode] = useState("")

    const send = () => {
        if(Functions.verifyEmail(email) === false){
            return
        }
        let verify = Functions.checkPasswordRestrictions(senha)
        console.log(verify, senha)
        toggleErrorPass(false)
        if(!verify.lenght || !verify.lowercase || !verify.special || !verify.uppercase){
            toggleErrorPass(true)
            return
        }

        axios.post(process.env.REACT_APP_RECOVER_SEND_URL!, {email, celular})
            .then((response)=> {
                toggleContent("RESET")
            })
            .catch((error)=> {
                switch(error.response.status){
                    case 400:
                        dispatch({type: 'ADD_NOTIFICATION', status: 3, title: "Bad request"})
                        toggle(false)
                        break
                    case 403:
                        dispatch({type: 'ADD_NOTIFICATION', status: 2, title: error.response.data.msg})
                        break
                }
            })
    }

    const sendCode = () => {
        return <Body.Content>
            <Body.Text>Insira os quatro últimos digitos de seu telefone e seu email para prosseguir com a redefinição.</Body.Text>
                <NumberInput setText={setCelular} />
                <div style={{marginBottom: 10}} />
                <Input placeholder="EMAIL" text={email} 
                    setText={setEmail} error={errorPass} />
                <Body.PasswordContent>
                    <Body.Icon src={passVisible?EyeIcon:EyeSplashIcon} 
                            onClick={()=>toggleVisibility(old => !old)}/>
                    <Input placeholder="NOVA SENHA" text={senha} 
                        setText={setSenha} error={errorPass}
                        secret={passVisible} />
                </Body.PasswordContent>
                <div style={{marginBottom: 20}} />
                <Button text="Alterar" action={()=>send()}/>
            </Body.Content>
    }

    const sendNewPass = () => {

        axios.post(process.env.REACT_APP_RECOVER_RECOVER_URL!, {email, senha, codigo_tfa})
            .then((response) => {
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: 'Senha alterada com sucesso'})
                toggle(false)
            })
            .catch((error)=> {
                switch(error.response.status){
                    case 400:
                        dispatch({type: 'ADD_NOTIFICATION', status: 3, title: 'Bad request'})
                        toggle(false)
                        break
                    case 403:
                        dispatch({type: 'ADD_NOTIFICATION', status: 2, title: error.response.data.msg})
                        break
                }
            })
    }

    const resendCode = () => {
		axios.get(process.env.REACT_APP_RESEND_URL!, {withCredentials: true})
			.then((response) => {	
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: "Código reenviado com sucesso"})	
			})
			.catch((error) => {
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: "Erro ao reenviar código " + error.response.status})
			})
	}

    const changePassword = () => {
        return <Body.Content>
                <Body.Text>Enviamos um código de para seu telefone, insira-o e forneça a nova senha para prosseguir.</Body.Text>
                <CodeInput setText={setCode} />
                <div style={{marginBottom: 20}} />
                <Body.Row style={{alignItems: 'center', justifyContent: 'center',
                    gridGap: '0px 10px'}}>
                    <Button text="Continuar" action={sendNewPass} />
                    <Button text="Reenviar código" action={resendCode} />
                </Body.Row>
                </Body.Content>
    }

    const getContent = () => {
        switch(content){
            case "SEND_CODE":
                return sendCode()
            case "RESET":
                return changePassword()
        }
    }

    return <Modal title="Alterar Senha" toggleModal={toggle}>
        {getContent()}
    </Modal>
}

// export const ChangePhoto: React.FC <ModalProp> = ({
//     toggle, 
// }) => {
//     const [attachament, setAttachament] = useState()
//     const [mensagem, setMensagem] = useState("")
//     const navigate = useNavigate()

//     const send = () => {

//         axios.put(process.env.REACT_APP_PASSWORD_URL!, {})
//             .then((response)=> {
//                 switch(response.data.code){
//                     case 200:
//                         toggle(false)
//                         break
//                     case 403:
//                         setMensagem("Token/Código inválido")
//                         break
//                     case 500:
//                         alert("Erro interno")
//                         break
//                 }
//             })
//             .catch((error)=> {
//                 alert('Erro: '+ error)
//             })
//     }


//     return <Modal title="Alterar foto" toggleModal={toggle}>
//         <Body.Content>
//             <Body.Row style={{alignItems: 'center'}}>
//                 <Body.Photo style={{width: '150px', height: '150px'}}
//                     src={attachament?attachament:avatar} />
//                 <Button text="Selecionar arquivo..." />
//             </Body.Row>
//             <Button text="Alterar" width={40} action={()=>send()}/>
//         </Body.Content>
//     </Modal>
// }


type ModalProps = {
    toggleModal: Dispatch<SetStateAction<boolean>>,
    user?: Types.User,
    getUsers?: any
}


const EditUser: React.FC <ModalProps> = ({
    toggleModal, user, getUsers
}) => {

    const [p_nome, setNome] = useState<string | undefined>(undefined)
    const [s_nome, setSobrenome] = useState<string | undefined>(undefined)
    const [email, setEmail] = useState<string | undefined>(undefined)
    const [telefone_ddd, setDDD] = useState<string | undefined>(undefined)
    const [telefone_numero, setTelefone] = useState<string | undefined>(undefined)

    const [content, toggleContent] = useState("SEND")
    const [loading, toggleLoading] = useState(false)

    const [codigo_tfa, setCode] = useState("")

    const [confirmModal, toggleConfirm] = useState(false)

    const dispatch = useDispatch()

    const tryDelete = () => {
        const token = user?.token
        axios.delete(process.env.REACT_APP_DELETE_USER_URL!+"?token="+token, {withCredentials: true})
            .then((response)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: 'Usuário removido com sucesso'})
                getUsers()
                toggleModal(false)
            })
            .catch((error)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: error.response.data.msg})
            })
    }

    const tryChange = () => {
        const token = user?.token
        toggleLoading(true)
        axios.put(process.env.REACT_APP_UPDATE_USER_URL!, {token, email, p_nome, s_nome, telefone_ddd, telefone_numero},
            {withCredentials: true})
            .then((response)=>{
                toggleContent("INSERT")
                toggleLoading(false)
            })
            .catch((error)=>{
                toggleLoading(false)
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: error.response.data.msg})
            })
    }

    const telefoneInsert = (text: string) => {
        if(telefone_numero?.length === 0){
            setTelefone(text)
            return
        }
        setTelefone(Regex.numberRegex(text, telefone_numero!))
    }

    const sendContent = () => {
        return <>
            <Body.Text>{user?.p_nome} {user?.s_nome}</Body.Text>
            <Body.Row>
                <Body.Half>
                    <Input text={p_nome!} setText={setNome} placeholder="NOME"/>
                </Body.Half>
                <Body.Half>
                    <Input text={s_nome!} setText={setSobrenome} placeholder="SOBRENOME"/>
                </Body.Half>
            </Body.Row>
            <Body.Row>
                <Body.Half style={{width: '100%'}}>
                    <Input text={email!} setText={setEmail} placeholder="EMAIL"/>
                </Body.Half>
            </Body.Row>
            <Body.Row style={{justifyContent: 'flex-start'}}>
                <Body.Half style={{width: '15%', marginRight: '15px', marginLeft: '5px'}}>
                    <Input text={telefone_ddd!} setText={setDDD} placeholder="DDD"/>
                </Body.Half>
                <Body.Half style={{width: '84%'}}>
                    <Input text={telefone_numero!} maxLenght={10} setText={telefoneInsert} placeholder="TELEFONE"/>
                </Body.Half>
            </Body.Row>
            <div style={{marginBottom: 20}} />
            <Button text="Alterar" action={tryChange} />        
            </>
    }

     const trySendCode = () => {
        const token = user?.token

        axios.put(process.env.REACT_APP_UPDATE_USER_URL!, {token, email, p_nome, s_nome, telefone_ddd, telefone_numero, codigo_tfa},
            {withCredentials: true})
            .then((response)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: 'Usuário alterado com sucesso'})
                getUsers()
                toggleModal(false)
            })
            .catch((error)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: error.response.data.msg})
            })
    }

    const resendCode = () => {
		axios.get(process.env.REACT_APP_RESEND_URL!, {withCredentials: true})
			.then((response) => {	
                dispatch({type: 'ADD_NOTIFICATION', status: 1, title: "Código reenviado com sucesso"})	
			})
			.catch((error) => {
                dispatch({type: 'ADD_NOTIFICATION', status: 3, title: "Erro ao reenviar código " + error.response.status})
			})
	}


    const insertCode = () => {
        return <>
            <Body.Text>Enviamos um código de autenticação para seu celular, 
                insira-o para prossguir com alteração dos dados</Body.Text>
            <CodeInput setText={setCode} />
            <div style={{marginBottom: 20}} />
            <Body.Row style={{alignItems: 'center', justifyContent: 'center',
                gridGap: '0px 10px'}}>
                <Button text="Continuar" action={trySendCode} />
                <Button text="Reenviar código" action={resendCode} />
            </Body.Row>
        </>
    }

    const getContent = () => {
        switch(content){
            case "SEND":
                return sendContent()
            case "INSERT":
                return insertCode()     
        }
    }

    return <> <Modal title="Alterar dados" remove={()=>toggleConfirm(true)} toggleModal={toggleModal}>
       <Body.Content>
        {getContent()}
       {loading? <Loading />:null}
       </Body.Content>
    </Modal> 
       {confirmModal?<Modal title="Deseja confirmar exlcusão?" >
        <div style={{display: 'flex', gridGap: '0px 20px' }}>
            <Button text="Confirmar" bg="#FF0000" bordercolor="#FF0000" action={tryDelete} />
            <Button text="Recusar" action={()=>toggleConfirm(false)} />
        </div>
       </Modal>:null}
    </>
}


export const EditUsers: React.FC <ModalProps> = ({
    toggleModal
}) => {

    const [users, setUsers] = useState<Types.UserList>()
    const [editUser, toggleEditUser] = useState(false)
    const [user, setUser] = useState<Types.User>()
    const dispatch = useDispatch()

    const selectUser = (item: Types.User) => {
        setUser(item)
        toggleEditUser(true)
    }

    const getData = () => {
        axios.get(process.env.REACT_APP_USERS_URL!, {withCredentials: true})
            .then((response)=>{
                setUsers(response.data)
            })
            .catch((error)=>{
                dispatch({type: 'ADD_NOTIFICATION', status: 2, title: error.response.data.msg})
            })
    }

    useEffect(()=>{
        getData()
    },[])

    return <><ListModal toggleModal={toggleModal} title="Editar usuários">
        <Body.UsersContent>
            {users?.map((item, index) => 
                <Body.UserBtn key={index.toString()} onClick={()=>selectUser(item)}>
                    <Body.Pefil style={{marginBottom: 0, alignItems: 'center'}}>
                        <Body.PerfilTextContent>
                            <Body.PerfilName style={{fontSize: '18px'}}>
                                {item.p_nome} {item.s_nome}
                            </Body.PerfilName>
                        </Body.PerfilTextContent>
                    </Body.Pefil>
                </Body.UserBtn>
                )}
        </Body.UsersContent>
    </ListModal>
    {editUser?<EditUser toggleModal={toggleEditUser} user={user!} getUsers={getData} />:null}
    </>
}

type UsinaAlarm = {
    token: string,
    nome: string,
    email: string,
    recebe_alarmes: boolean,
    recebe_relatorios: boolean,
    recebe_manutencao: boolean,
    recebe_conexao: boolean,
    push_status_alarmes: boolean,
    push_manutencao: boolean,
}

// Faixas de horário (sempre em UTC) em que o usuário deseja receber push. Sem faixas = 24/7.
type PushHorarioRange = {
    dias: number[]  // 0=domingo ... 6=sábado (UTC)
    inicio: string   // "HH:MM" UTC
    fim: string      // "HH:MM" UTC — se fim <= inicio, cruza a meia-noite
}

const DIAS_SEMANA_LABEL = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

// Offsets de UTC disponíveis no select (-12 a +14, em horas cheias).
const UTC_OFFSETS = Array.from({ length: 27 }, (_, i) => i - 12)

function offsetLabel(offset: number): string {
    return `UTC${offset >= 0 ? '+' : ''}${offset}`
}

function defaultUtcOffset(): number {
    return Math.round(-new Date().getTimezoneOffset() / 60)
}

function mod(n: number, m: number): number {
    return ((n % m) + m) % m
}

function horarioToMin(hhmm: string): number {
    const [h, m] = hhmm.split(':').map(Number)
    return h * 60 + m
}

function minToHorario(min: number): string {
    const h = Math.floor(min / 60), m = min % 60
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

// Desloca uma faixa (dias + horários) por deltaHours, ajustando o dia quando o horário cruza a meia-noite.
function shiftRange(range: PushHorarioRange, deltaHours: number): PushHorarioRange {
    const deltaMin = deltaHours * 60
    const oldInicio = horarioToMin(range.inicio)
    const dayShift = Math.floor((oldInicio + deltaMin) / 1440)
    return {
        dias: range.dias.map(d => mod(d + dayShift, 7)).sort(),
        inicio: minToHorario(mod(oldInicio + deltaMin, 1440)),
        fim: minToHorario(mod(horarioToMin(range.fim) + deltaMin, 1440)),
    }
}

function faixasSeSobrepoem(ranges: PushHorarioRange[]): boolean {
    type Slice = { dia: number, inicio: number, fim: number }
    const toMin = (hhmm: string) => { const [h, m] = hhmm.split(':').map(Number); return h * 60 + m }
    const slices: Slice[] = ranges.flatMap(r => {
        const inicio = toMin(r.inicio), fim = toMin(r.fim)
        return r.dias.flatMap(dia => fim > inicio
            ? [{ dia, inicio, fim }]
            : [{ dia, inicio, fim: 1440 }, { dia: (dia + 1) % 7, inicio: 0, fim }])
    })
    for (let i = 0; i < slices.length; i++)
        for (let j = i + 1; j < slices.length; j++) {
            const a = slices[i], b = slices[j]
            if (a.dia === b.dia && a.inicio < b.fim && b.inicio < a.fim) return true
        }
    return false
}

type AlarmsReportsProps = {
    toggle: Dispatch<SetStateAction<boolean>>,
    loading: boolean,
    setLoading: Dispatch<SetStateAction<boolean>>
}

export const AlarmsReports: React.FC<AlarmsReportsProps> = ({ toggle, loading, setLoading }) => {
    const [usinas, setUsinas] = useState<UsinaAlarm[]>([])
    const [email, setEmail] = useState('')
    const [serverEmail, setServerEmail] = useState('')
    const [emailVerificado, setEmailVerificado] = useState(false)
    const [codigoPendente, setCodigoPendente] = useState(false)
    const [codigoEnviadoEm, setCodigoEnviadoEm] = useState<string | null>(null)
    const [codigo, setCodigo] = useState('')
    const [enviandoCodigo, setEnviandoCodigo] = useState(false)
    const [confirmandoCodigo, setConfirmandoCodigo] = useState(false)
    const [agora, setAgora] = useState(Date.now())
    const [pushStatus, setPushStatus] = useState<'granted' | 'denied' | 'unsupported' | 'default'>('default')
    const [pushLoading, setPushLoading] = useState(false)
    const [horarioRanges, setHorarioRanges] = useState<PushHorarioRange[]>([])
    const [utcOffset, setUtcOffset] = useState<number>(defaultUtcOffset())
    const isMobile = useIsMobile()
    const dispatch = useDispatch()

    useEffect(() => {
        // No mock, simula permissão concedida — o ambiente de teste não permite ativar push de verdade.
        setPushStatus(USE_MOCK ? 'granted' : getPushPermissionStatus() as any)
    }, [])

    // Carrega o estado de verificação do e-mail — vem do servidor para persistir entre fechar/abrir o modal.
    useEffect(() => {
        if (USE_MOCK) {
            setEmail('operacao@saojao.com.br')
            setServerEmail('operacao@saojao.com.br')
            setEmailVerificado(true)
            return
        }
        api.get(`${getApiBaseUrl()}/email-verificacao`)
            .then(res => {
                const { email: emailAtual, emailVerificado: verificado, codigoPendente: pendente, codigoEnviadoEm: enviadoEm } = res.data
                if (emailAtual) {
                    setEmail(emailAtual)
                    setServerEmail(emailAtual)
                    setEmailVerificado(!!verificado)
                    setCodigoPendente(!!pendente)
                    setCodigoEnviadoEm(enviadoEm ?? null)
                }
            })
            .catch(err => console.error('Erro ao carregar verificação de e-mail:', err))
    }, [])

    // Tick para recalcular o cooldown de reenvio em tempo real.
    useEffect(() => {
        const id = setInterval(() => setAgora(Date.now()), 1000)
        return () => clearInterval(id)
    }, [])

    useEffect(() => {
        if (USE_MOCK) {
            const moendas: UsinaAlarm[] = mockUsinas.map(m => ({
                token: m.token,
                nome: m.nome,
                email: m.email,
                recebe_alarmes: m.recebe_alarmes,
                recebe_relatorios: m.recebe_relatorios,
                recebe_manutencao: (m as any).recebe_manutencao ?? true,
                recebe_conexao: (m as any).recebe_conexao ?? false,
                push_status_alarmes: (m as any).push_status_alarmes ?? true,
                push_manutencao: (m as any).push_manutencao ?? true,
            }))
            setUsinas(moendas)
            // E-mail é carregado separadamente via /email-verificacao (ver useEffect acima).
            // Exemplo de faixa já preenchida, só para visualização no mock.
            setHorarioRanges([
                { dias: [1, 2, 3, 4, 5], inicio: '08:00', fim: '18:00' },
                { dias: [0, 6], inicio: '10:00', fim: '14:00' },
            ])
            return
        }
        setLoading(true)
        api.get(`${getApiBaseUrl()}/moendas`)
            .then(response => {
                const moendas: UsinaAlarm[] = (response.data.moendas ?? []).map((m: any) => ({
                    token: m.token,
                    nome: m.nome,
                    email: m.email ?? '',
                    recebe_alarmes: !!m.recebe_alarmes,
                    recebe_relatorios: !!m.recebe_relatorios,
                    recebe_manutencao: m.recebe_manutencao !== undefined ? !!m.recebe_manutencao : true,
                    recebe_conexao: !!m.recebe_conexao,
                    push_status_alarmes: m.push_status_alarmes !== undefined ? !!m.push_status_alarmes : true,
                    push_manutencao: m.push_manutencao !== undefined ? !!m.push_manutencao : true,
                }))
                setUsinas(moendas)
                // E-mail é carregado separadamente via /email-verificacao (ver useEffect acima).
            })
            .catch(err => {
                dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'Erro ao carregar configurações' })
                console.error(err)
            })
            .finally(() => setLoading(false))
    }, [])

    const handleAlarmeToggle = (token: string) => {
        setUsinas(usinas.map(u => u.token === token ? { ...u, recebe_alarmes: !u.recebe_alarmes } : u))
    }

    const handleRelatorioToggle = (token: string) => {
        setUsinas(usinas.map(u => u.token === token ? { ...u, recebe_relatorios: !u.recebe_relatorios } : u))
    }

    const handleManutencaoToggle = (token: string) => {
        setUsinas(usinas.map(u => u.token === token ? { ...u, recebe_manutencao: !u.recebe_manutencao } : u))
    }

    const handleConexaoToggle = (token: string) => {
        setUsinas(usinas.map(u => u.token === token ? { ...u, recebe_conexao: !u.recebe_conexao } : u))
    }

    const handlePushStatusToggle = (token: string) => {
        setUsinas(usinas.map(u => u.token === token ? { ...u, push_status_alarmes: !u.push_status_alarmes } : u))
    }

    const handlePushManutencaoToggle = (token: string) => {
        setUsinas(usinas.map(u => u.token === token ? { ...u, push_manutencao: !u.push_manutencao } : u))
    }

    const handleEnviarCodigo = () => {
        const emailDigitado = email.trim()
        if (!emailDigitado) return
        setEnviandoCodigo(true)
        if (USE_MOCK) {
            setServerEmail(emailDigitado)
            setEmailVerificado(false)
            setCodigoPendente(true)
            setCodigoEnviadoEm(new Date().toISOString())
            dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: `[MOCK] Código enviado para ${emailDigitado}` })
            setEnviandoCodigo(false)
            return
        }
        api.post(`${getApiBaseUrl()}/email-verificacao/enviar`, { email: emailDigitado })
            .then(res => {
                setServerEmail(emailDigitado)
                if (res.data.jaVerificado) {
                    setEmailVerificado(true)
                    setCodigoPendente(false)
                    dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: 'E-mail já verificado' })
                } else {
                    setEmailVerificado(false)
                    setCodigoPendente(true)
                    setCodigoEnviadoEm(res.data.enviadoEm)
                    dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: `Código enviado para ${emailDigitado}` })
                }
            })
            .catch(err => {
                dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: err?.response?.data?.message || 'Erro ao enviar código de verificação' })
            })
            .finally(() => setEnviandoCodigo(false))
    }

    const handleConfirmarCodigo = () => {
        if (codigo.trim().length !== 6) return
        setConfirmandoCodigo(true)
        if (USE_MOCK) {
            setEmailVerificado(true)
            setCodigoPendente(false)
            setCodigo('')
            dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: '[MOCK] E-mail verificado com sucesso!' })
            setConfirmandoCodigo(false)
            return
        }
        api.post(`${getApiBaseUrl()}/email-verificacao/confirmar`, { codigo: codigo.trim() })
            .then(() => {
                setEmailVerificado(true)
                setCodigoPendente(false)
                setCodigo('')
                dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: 'E-mail verificado com sucesso!' })
            })
            .catch(err => {
                dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: err?.response?.data?.message || 'Código inválido' })
            })
            .finally(() => setConfirmandoCodigo(false))
    }

    // As faixas ficam guardadas em UTC (horarioRanges); a UI trabalha no offset escolhido pelo
    // usuário (utcOffset) e converte de volta para UTC a cada edição.
    const handleAddRange = () => {
        const novaFaixaNoOffsetEscolhido: PushHorarioRange = { dias: [1, 2, 3, 4, 5], inicio: '08:00', fim: '18:00' }
        setHorarioRanges([...horarioRanges, shiftRange(novaFaixaNoOffsetEscolhido, -utcOffset)])
    }

    const handleRemoveRange = (index: number) => {
        setHorarioRanges(horarioRanges.filter((_, i) => i !== index))
    }

    const handleToggleDia = (index: number, dia: number) => {
        setHorarioRanges(horarioRanges.map((r, i) => {
            if (i !== index) return r
            const display = shiftRange(r, utcOffset)
            const dias = display.dias.includes(dia) ? display.dias.filter(d => d !== dia) : [...display.dias, dia]
            return shiftRange({ ...display, dias }, -utcOffset)
        }))
    }

    const handleChangeHorario = (index: number, field: 'inicio' | 'fim', value: string) => {
        setHorarioRanges(horarioRanges.map((r, i) => {
            if (i !== index) return r
            const display = shiftRange(r, utcOffset)
            return shiftRange({ ...display, [field]: value }, -utcOffset)
        }))
    }

    const handleActivatePush = async () => {
        if (usinas.length === 0) return
        setPushLoading(true)
        const result = await requestAndRegisterPush(usinas[0].token)
        setPushStatus(result)
        setPushLoading(false)
        if (result === 'granted') {
            dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: 'Notificações push ativadas!' })
        } else if (result === 'denied') {
            dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'Permissão de notificação bloqueada pelo browser' })
        }
    }

    const handleSave = () => {
        if (horarioRanges.some(r => r.dias.length === 0)) {
            dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'Selecione ao menos um dia da semana em cada faixa de horário' })
            return
        }
        if (faixasSeSobrepoem(horarioRanges)) {
            dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'As faixas de horário não podem se sobrepor' })
            return
        }
        if (USE_MOCK) {
            dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: '[MOCK] Configurações salvas com sucesso' })
            toggle(false)
            return
        }
        setLoading(true)
        const payload = {
            usinas: usinas.map(u => ({
                token: u.token,
                recebe_alarmes:      u.recebe_alarmes,
                recebe_relatorios:   u.recebe_relatorios,
                recebe_manutencao:   u.recebe_manutencao,
                recebe_conexao:      u.recebe_conexao,
                push_status_alarmes: u.push_status_alarmes,
                push_manutencao:     u.push_manutencao,
                push_horario_ranges: horarioRanges,
            }))
        }
        api.put(`${getApiBaseUrl()}/usuario-alarmes`, payload)
            .then(() => {
                dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: 'Configurações salvas com sucesso' })
                toggle(false)
            })
            .catch(err => {
                dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: err?.response?.data?.message || 'Erro ao salvar configurações' })
                console.error(err)
            })
            .finally(() => setLoading(false))
    }

    // ── Estilos locais ───────────────────────────────────────────────
    const card: React.CSSProperties = {
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 16,
        overflow: 'hidden',
        marginBottom: 10,
    }
    const cardHeader = (color: string): React.CSSProperties => ({
        display: 'flex', alignItems: 'flex-start', gap: 14,
        padding: '16px 18px 14px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
    })
    const iconWrap = (color: string): React.CSSProperties => ({
        width: 38, height: 38, borderRadius: 10, flexShrink: 0,
        background: `${color}18`,
        border: `1px solid ${color}40`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    })
    const cardTitle: React.CSSProperties = {
        fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: 13,
        color: 'rgba(255,255,255,0.9)', marginBottom: 3,
    }
    const cardDesc: React.CSSProperties = {
        fontFamily: 'Nunito, sans-serif', fontSize: 12,
        color: 'rgba(255,255,255,0.45)', lineHeight: 1.5,
    }
    const usinaRow: React.CSSProperties = {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '10px 18px',
        borderBottom: '1px solid rgba(255,255,255,0.04)',
    }
    const usinaName: React.CSSProperties = {
        fontFamily: 'Nunito, sans-serif', fontSize: 13, fontWeight: 600,
        color: 'rgba(255,255,255,0.75)',
    }

    // Renderiza as linhas de usinas de um determinado tipo de toggle
    const UsinaRows = ({
        field, onToggle,
    }: {
        field: keyof UsinaAlarm;
        onToggle: (token: string) => void;
    }) => {
        if (loading) return (
            <div style={{ padding: '12px 18px', fontFamily: 'Nunito,sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
                Carregando...
            </div>
        )
        if (usinas.length === 0) return (
            <div style={{ padding: '12px 18px', fontFamily: 'Nunito,sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.3)' }}>
                Nenhuma usina encontrada
            </div>
        )
        return (
            <>
                {usinas.map((u, i) => (
                    <div key={u.token} style={{ ...usinaRow, borderBottom: i < usinas.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none' }}>
                        <span style={usinaName}>{u.nome}</span>
                        <ToggleSwitch isOn={!!u[field]} onToggle={() => onToggle(u.token)} />
                    </div>
                ))}
            </>
        )
    }

    // E-mail digitado precisa bater com o que o servidor reconhece (verificado ou com código pendente)
    // para mostrar o badge/campo correspondente — trocar o valor ou voltar ao já-verificado escondem tudo.
    const emailCorrespondeAoServidor = !!serverEmail && email.trim() === serverEmail.trim()
    const mostrarBadgeVerificado = emailCorrespondeAoServidor && emailVerificado
    const mostrarCampoCodigo = emailCorrespondeAoServidor && codigoPendente && !emailVerificado
    const cooldownRestanteMs = codigoEnviadoEm ? Math.max(0, new Date(codigoEnviadoEm).getTime() + 5 * 60 * 1000 - agora) : 0
    const podeReenviar = cooldownRestanteMs <= 0

    return <>
    <ListModal toggleModal={handleSave} title="Alarmes e Relatórios">
        <Body.Content style={{ width: '100%', maxHeight: '760px', display: 'flex', flexDirection: 'column' }}>
            <Body.Scroll style={{ width: '100%', flex: 1, padding: '2px 0 8px' }}>

                {/* ── E-mail ── */}
                <div style={card}>
                    <div style={cardHeader('#5292D1')}>
                        <div style={iconWrap('#5292D1')}>
                            <Mail size={18} color="#5292D1" strokeWidth={1.8} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={cardTitle}>E-mail para notificações</div>
                            <div style={cardDesc}>Endereço que receberá todos os alertas e relatórios das suas usinas.</div>
                        </div>
                    </div>
                    <div style={{ padding: '14px 18px' }}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ flex: 1 }}>
                                <Input placeholder="SEU EMAIL" text={email} setText={setEmail} />
                            </div>
                            {mostrarBadgeVerificado ? (
                                <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#92B258', fontFamily: 'Nunito,sans-serif', fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0 }}>
                                    <CheckCircle2 size={14} strokeWidth={2} /> Verificado
                                </span>
                            ) : !mostrarCampoCodigo && (
                                <button onClick={handleEnviarCodigo} disabled={enviandoCodigo || !email.trim()} type="button"
                                    style={{ flexShrink: 0, padding: '8px 14px', borderRadius: 20, border: '1px solid rgba(82,146,209,0.4)', background: 'rgba(82,146,209,0.12)', color: '#5292D1', fontFamily: 'Nunito,sans-serif', fontWeight: 700, fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap', opacity: (enviandoCodigo || !email.trim()) ? 0.5 : 1 }}>
                                    {enviandoCodigo ? 'Enviando...' : 'Verificar e-mail'}
                                </button>
                            )}
                        </div>

                        {!mostrarBadgeVerificado && !mostrarCampoCodigo && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, fontFamily: 'Nunito,sans-serif', fontSize: 11, color: '#E5D34A' }}>
                                <AlertTriangle size={16} strokeWidth={2} />
                                E-mail não verificado. Alertas e relatórios não serão enviados até a verificação.
                            </div>
                        )}

                        {mostrarCampoCodigo && (
                            <div style={{ marginTop: 10, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: 12 }}>
                                <div style={{ fontFamily: 'Nunito,sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.6)', marginBottom: 10 }}>
                                    Enviamos um código de 6 dígitos para <strong style={{ color: '#fff' }}>{serverEmail}</strong>. Ele expira em 24h.
                                </div>
                                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                    <input value={codigo} onChange={e => setCodigo(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                        placeholder="000000" maxLength={6} inputMode="numeric"
                                        style={{ width: 100, textAlign: 'center', letterSpacing: 4, fontSize: 16, fontFamily: 'Nunito,sans-serif', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, color: '#fff', padding: '8px 10px', boxSizing: 'border-box' }} />
                                    <button onClick={handleConfirmarCodigo} disabled={confirmandoCodigo || codigo.length !== 6} type="button"
                                        style={{ padding: '8px 16px', borderRadius: 20, border: '1px solid #92B25880', background: 'rgba(146,178,88,0.15)', color: '#92B258', fontFamily: 'Nunito,sans-serif', fontWeight: 700, fontSize: 12, cursor: 'pointer', opacity: (confirmandoCodigo || codigo.length !== 6) ? 0.5 : 1 }}>
                                        {confirmandoCodigo ? 'Confirmando...' : 'Confirmar'}
                                    </button>
                                    <button onClick={handleEnviarCodigo} disabled={!podeReenviar || enviandoCodigo} type="button"
                                        style={{ padding: '8px 12px', borderRadius: 20, border: '1px solid rgba(255,255,255,0.1)', background: 'transparent', color: podeReenviar ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.3)', fontFamily: 'Nunito,sans-serif', fontSize: 12, cursor: podeReenviar ? 'pointer' : 'default' }}>
                                        {podeReenviar ? 'Reenviar código' : `Reenviar em ${Math.ceil(cooldownRestanteMs / 60000)}min`}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* ── Relatórios semanais ── */}
                <div style={card}>
                    <div style={cardHeader('#5292D1')}>
                        <div style={iconWrap('#5292D1')}>
                            <BarChart2 size={18} color="#5292D1" strokeWidth={1.8} />
                        </div>
                        <div>
                            <div style={cardTitle}>Relatórios semanais</div>
                            <div style={cardDesc}>Toda sexta-feira às 08h (UTC-3), exibindo dados de operação, disponibilidade e manutenção.</div>
                        </div>
                    </div>
                    <UsinaRows field="recebe_relatorios" onToggle={handleRelatorioToggle} />
                </div>

                {/* ── Alarmes em tempo real ── */}
                <div style={card}>
                    <div style={cardHeader('#F03F3F')}>
                        <div style={iconWrap('#F03F3F')}>
                            <AlertTriangle size={18} color="#F03F3F" strokeWidth={1.8} />
                        </div>
                        <div>
                            <div style={cardTitle}>Alarmes em tempo real</div>
                            <div style={cardDesc}>Notificado por e-mail a cada mudança de status de alarme detectada na moenda.</div>
                        </div>
                    </div>
                    <UsinaRows field="recebe_alarmes" onToggle={handleAlarmeToggle} />
                </div>

                {/* ── Alertas de manutenção ── */}
                <div style={card}>
                    <div style={cardHeader('#E8A84C')}>
                        <div style={iconWrap('#E8A84C')}>
                            <Wrench size={18} color="#E8A84C" strokeWidth={1.8} />
                        </div>
                        <div>
                            <div style={cardTitle}>Alertas de manutenção</div>
                            <div style={cardDesc}>Temperatura do óleo, umidade ou filtro fora dos limites. É reenviado a cada 24h ou se houver uma variação elevada.</div>
                        </div>
                    </div>
                    <UsinaRows field="recebe_manutencao" onToggle={handleManutencaoToggle} />
                </div>

                {/* ── Alertas de conexão ── */}
                <div style={card}>
                    <div style={cardHeader('#E5D34A')}>
                        <div style={iconWrap('#E5D34A')}>
                            <Wifi size={18} color="#E5D34A" strokeWidth={1.8} />
                        </div>
                        <div>
                            <div style={cardTitle}>Alertas de conexão</div>
                            <div style={cardDesc}>Falha de comunicação do Obsidian com o CLP ou usina sem envio de dados por mais de 24h.</div>
                        </div>
                    </div>
                    <UsinaRows field="recebe_conexao" onToggle={handleConexaoToggle} />
                </div>

                {/* ── Push notifications ── */}
                <div style={card}>
                    <div style={{ ...cardHeader('#92B258'), borderBottom: 'none' }}>
                        <div style={iconWrap('#92B258')}>
                            <BellRing size={18} color="#92B258" strokeWidth={1.8} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={cardTitle}>Notificações via navegador</div>
                            <div style={cardDesc}>Seja notificado pelo browser por alarmes do sistema mesmo sem o site estar aberto.</div>
                        </div>
                        {/* Status / botão de ativação */}
                        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', marginLeft: 12 }}>
                            {pushStatus === 'granted' ? (
                                <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 12, color: '#92B258', fontWeight: 700, whiteSpace: 'nowrap' }}>✓ Ativo</span>
                            ) : pushStatus === 'denied' ? (
                                <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 11, color: '#F03F3F', maxWidth: 120, lineHeight: 1.3 }}>Bloqueado — habilite no navegador</span>
                            ) : pushStatus === 'unsupported' ? (
                                <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>Não suportado</span>
                            ) : (
                                <button
                                    onClick={handleActivatePush}
                                    disabled={pushLoading}
                                    style={{ padding: '6px 14px', borderRadius: 20, border: '1px solid #92B25880', background: 'rgba(146,178,88,0.12)', color: '#92B258', fontFamily: 'Nunito,sans-serif', fontWeight: 700, fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap', opacity: pushLoading ? 0.6 : 1 }}
                                >
                                    {pushLoading ? 'Ativando...' : 'Ativar'}
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Sub-toggles por usina — só aparece se push está ativo */}
                    {pushStatus === 'granted' && usinas.length > 0 && (
                        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
                            {usinas.map((u, i) => (
                                <div key={u.token} style={{ ...usinaRow, borderBottom: i < usinas.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none' }}>
                                    <span style={usinaName}>{u.nome}</span>
                                    <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                                            <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 10, color: 'rgba(255,255,255,0.35)', letterSpacing: 0.3 }}>ALARMES</span>
                                            <ToggleSwitch isOn={u.push_status_alarmes} onToggle={() => handlePushStatusToggle(u.token)} />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                                            <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 10, color: 'rgba(255,255,255,0.35)', letterSpacing: 0.3 }}>MANUTENÇÃO</span>
                                            <ToggleSwitch isOn={u.push_manutencao} onToggle={() => handlePushManutencaoToggle(u.token)} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Horário de recebimento — só vale para push, e-mail continua 24/7 */}
                    {pushStatus === 'granted' && (
                        <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '14px 18px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                                <Clock size={14} color="rgba(255,255,255,0.45)" strokeWidth={1.8} />
                                <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: 12, color: 'rgba(255,255,255,0.75)' }}>Horário de recebimento</span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }}>
                                    <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>Fuso</span>
                                    <select value={utcOffset} onChange={e => setUtcOffset(Number(e.target.value))}
                                        style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, color: '#fff', fontFamily: 'Nunito,sans-serif', fontSize: 12, padding: '4px 6px' }}>
                                        {UTC_OFFSETS.map(o => <option key={o} value={o}>{offsetLabel(o)}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div style={{ ...cardDesc, marginBottom: 10 }}>
                                Os horários abaixo seguem o fuso selecionado ({offsetLabel(utcOffset)}). Sem nenhuma faixa cadastrada, a notificação é enviado a qualquer hora (24/7).
                            </div>

                            {horarioRanges.map((utcRange, index) => {
                                const range = shiftRange(utcRange, utcOffset)
                                return (
                                    <div key={index} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: 10, marginBottom: 8 }}>
                                        <div style={{ display: 'flex', flexWrap: isMobile ? 'nowrap' : 'wrap', gap: isMobile ? 3 : 6, marginBottom: 8 }}>
                                            {DIAS_SEMANA_LABEL.map((label, dia) => (
                                                <button key={dia} onClick={() => handleToggleDia(index, dia)} type="button"
                                                    style={{
                                                        boxSizing: 'border-box',
                                                        flex: isMobile ? '1 1 0%' : '0 0 32px', minWidth: 0, flexShrink: isMobile ? 1 : 0,
                                                        height: isMobile ? 34 : 26, borderRadius: 6, cursor: 'pointer',
                                                        border: range.dias.includes(dia) ? '1px solid #92B25880' : '1px solid rgba(255,255,255,0.1)',
                                                        background: range.dias.includes(dia) ? 'rgba(146,178,88,0.2)' : 'rgba(255,255,255,0.04)',
                                                        color: range.dias.includes(dia) ? '#92B258' : 'rgba(255,255,255,0.4)',
                                                        fontFamily: 'Nunito,sans-serif', fontSize: isMobile ? 10 : 10, fontWeight: 700,
                                                        padding: 0, overflow: 'hidden', whiteSpace: 'nowrap',
                                                    }}>
                                                    {label}
                                                </button>
                                            ))}
                                            {!isMobile && (
                                                <button onClick={() => handleRemoveRange(index)} type="button"
                                                    style={{ marginLeft: 'auto', flexShrink: 0, width: 26, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, border: '1px solid rgba(240,63,63,0.3)', background: 'rgba(240,63,63,0.08)', cursor: 'pointer' }}>
                                                    <Trash2 size={13} color="#F03F3F" strokeWidth={1.8} />
                                                </button>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', justifyContent: isMobile ? 'space-between' : 'flex-start' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 11, color: 'rgba(255,255,255,0.45)' }}>De</span>
                                                    <input type="time" value={range.inicio} onChange={e => handleChangeHorario(index, 'inicio', e.target.value)}
                                                        style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, color: '#fff', fontFamily: 'Nunito,sans-serif', fontSize: 13, padding: '5px 8px' }} />
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 11, color: 'rgba(255,255,255,0.45)' }}>até</span>
                                                    <input type="time" value={range.fim} onChange={e => handleChangeHorario(index, 'fim', e.target.value)}
                                                        style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, color: '#fff', fontFamily: 'Nunito,sans-serif', fontSize: 13, padding: '5px 8px' }} />
                                                </div>
                                            </div>
                                            {isMobile && (
                                                <button onClick={() => handleRemoveRange(index)} type="button"
                                                    style={{ flexShrink: 0, width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, border: '1px solid rgba(240,63,63,0.3)', background: 'rgba(240,63,63,0.08)', cursor: 'pointer' }}>
                                                    <Trash2 size={13} color="#F03F3F" strokeWidth={1.8} />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )
                            })}

                            <button onClick={handleAddRange} type="button"
                                style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '7px 12px', color: 'rgba(255,255,255,0.6)', fontFamily: 'Nunito,sans-serif', fontSize: 12, cursor: 'pointer' }}>
                                <Plus size={13} strokeWidth={2} />
                                Adicionar faixa de horário
                            </button>
                        </div>
                    )}
                </div>

            </Body.Scroll>
        </Body.Content>
    </ListModal>
    </>
}

// ── Modal: Gerar Relatório Sob Demanda ────────────────────────────

type GerarRelatorioProps = {
    toggle: Dispatch<SetStateAction<boolean>>,
}

type UsinaToken = { token: string; nome: string }

// Componente independente — botão "Gerar relatório" mora na Home, ao lado de "Configurar", em
// vez de dentro do modal "Alarmes e Relatórios". Busca a própria lista de usinas e o e-mail
// verificado (antes vinham como props do AlarmsReports, que não é mais o pai deste componente).
export const GerarRelatorio: React.FC<GerarRelatorioProps> = React.memo(({ toggle }) => {
    const isMobile = useIsMobile()
    const [usinas, setUsinas] = useState<UsinaToken[]>([])
    const [email, setEmail] = useState('')
    const [selectedToken, setSelectedToken] = useState('')
    const [startDate, setStartDate] = useState<Date | null>(null)
    const [endDate, setEndDate] = useState<Date | null>(null)
    const [comparar, setComparar] = useState(false)
    const [compStartDate, setCompStartDate] = useState<Date | null>(null)
    const [compEndDate, setCompEndDate] = useState<Date | null>(null)
    const [loading, setLoading] = useState(false)
    const [btnHover, setBtnHover] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (USE_MOCK) {
            const moendas = mockUsinas.map(m => ({ token: m.token, nome: m.nome }))
            setUsinas(moendas)
            setSelectedToken(moendas[0]?.token ?? '')
            setEmail('operacao@saojao.com.br')
            return
        }
        api.get(`${getApiBaseUrl()}/moendas`)
            .then(response => {
                const moendas: UsinaToken[] = (response.data.moendas ?? []).map((m: any) => ({ token: m.token, nome: m.nome }))
                setUsinas(moendas)
                setSelectedToken(moendas[0]?.token ?? '')
            })
            .catch(err => console.error('Erro ao carregar usinas:', err))
        api.get(`${getApiBaseUrl()}/email-verificacao`)
            .then(res => { if (res.data.email) setEmail(res.data.email) })
            .catch(err => console.error('Erro ao carregar verificação de e-mail:', err))
    }, [])

    const handleGenerate = () => {
        if (!startDate || !endDate) {
            dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'Informe o período para o relatório' })
            return
        }
        if (comparar && (!compStartDate || !compEndDate)) {
            dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'Informe o período de comparação' })
            return
        }
        if (USE_MOCK) {
            dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: `[MOCK] Relatório enviado para ${email || 'mock@email.com'}` })
            toggle(false)
            return
        }
        setLoading(true)
        // Flatpickr sem horário devolve meia-noite local do dia escolhido — sem isso, "fim" vira
        // meia-noite do próprio dia final e a busca [inicio, fim] fecha num intervalo de duração
        // zero, sem bater com nenhum dado real (causa do "Nenhum dado encontrado para o período").
        const fimDoDia = (d: Date) => { const e = new Date(d); e.setHours(23, 59, 59, 999); return e }
        const body: any = { token: selectedToken, inicio: startDate.toISOString(), fim: fimDoDia(endDate).toISOString() }
        if (comparar && compStartDate && compEndDate) {
            body.comparacao = { inicio: compStartDate.toISOString(), fim: fimDoDia(compEndDate).toISOString() }
        }
        axios.post(`${getApiBaseUrl()}/relatorio`, body, { withCredentials: true })
            .then(() => { dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: `Relatório enviado para ${email}` }); toggle(false) })
            .catch(() => dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: 'Erro ao gerar relatório' }))
            .finally(() => setLoading(false))
    }

    // ── Constantes de estilo ──────────────────────────────────────
    const grCard: React.CSSProperties = {
        width: '100%', boxSizing: 'border-box',
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 14, marginBottom: 10, overflow: 'hidden',
    }
    const microLabel: React.CSSProperties = {
        fontFamily: 'Roboto,sans-serif', fontSize: 10, fontWeight: 600,
        color: 'rgba(255,255,255,0.35)', letterSpacing: 1,
        textTransform: 'uppercase' as const, marginBottom: 5,
    }
    const fpInputStyle = `
        .gr-fp-wrap .flatpickr-input {
            width: 100%; box-sizing: border-box;
            background: rgba(255,255,255,0.06);
            border: 1px solid rgba(255,255,255,0.12);
            border-radius: 10px; color: #fff;
            font-family: 'Nunito', sans-serif; font-size: 13px;
            padding: 10px 12px; outline: none; cursor: pointer;
            transition: border-color 0.15s;
        }
        .gr-fp-wrap .flatpickr-input:focus,
        .gr-fp-wrap .flatpickr-input.active { border-color: #5292D1; }
        @media (max-width: 600px) {
            .gr-fp-wrap .flatpickr-input { font-size: 16px; }
        }
        ${FP_CALENDAR_THEME}
    `
    // Memoizados: react-flatpickr destrói e recria a instância (fechando o calendário aberto)
    // toda vez que a referência de `options` muda — por isso só mudam quando o limite do OUTRO
    // campo do mesmo período muda (necessário para o destaque dhm-fp-other-bound).
    const inicioFpOpts = useMemo(() => ({
        enableTime: false, dateFormat: 'd/m/Y', locale: Portuguese, appendTo: document.body, disableMobile: true,
        onDayCreate: markOtherBound(endDate),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [endDate])
    const fimFpOpts = useMemo(() => ({
        enableTime: false, dateFormat: 'd/m/Y', locale: Portuguese, appendTo: document.body, disableMobile: true,
        onDayCreate: markOtherBound(startDate),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [startDate])
    const compInicioFpOpts = useMemo(() => ({
        enableTime: false, dateFormat: 'd/m/Y', locale: Portuguese, appendTo: document.body, disableMobile: true,
        onDayCreate: markOtherBound(compEndDate),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [compEndDate])
    const compFimFpOpts = useMemo(() => ({
        enableTime: false, dateFormat: 'd/m/Y', locale: Portuguese, appendTo: document.body, disableMobile: true,
        onDayCreate: markOtherBound(compStartDate),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [compStartDate])

    // react-select dark styles (padrão do sistema)
    type UsinaOpt = { value: string; label: string }
    const usinaOptions: UsinaOpt[] = usinas.map(u => ({ value: u.token, label: u.nome }))
    const usinaSelected = usinaOptions.find(o => o.value === selectedToken) ?? null
    const SELECT_FONT = 'Nunito, sans-serif'
    const selectStyles = {
        control: (b: any, s: any) => ({ ...b, background: 'rgba(255,255,255,0.06)', borderColor: s.isFocused ? '#5292D1' : 'rgba(255,255,255,0.12)', borderRadius: 10, fontSize: 13, fontFamily: SELECT_FONT, boxShadow: 'none', minHeight: 40, cursor: 'pointer', '&:hover': { borderColor: '#5292D1' } }),
        menu:       (b: any) => ({ ...b, background: '#1e2b3a', borderRadius: 10, border: '1px solid rgba(255,255,255,0.12)', zIndex: 9999 }),
        menuPortal: (b: any) => ({ ...b, zIndex: 9999 }),
        option:     (b: any, s: any) => ({ ...b, background: s.isSelected ? '#5292D1' : s.isFocused ? 'rgba(82,146,209,0.2)' : 'transparent', color: s.isSelected ? '#fff' : 'rgba(255,255,255,0.8)', fontSize: 13, fontFamily: SELECT_FONT, cursor: 'pointer' }),
        singleValue:(b: any) => ({ ...b, color: '#fff', fontSize: 13, fontFamily: SELECT_FONT }),
        placeholder:(b: any) => ({ ...b, color: 'rgba(255,255,255,0.3)', fontSize: 13, fontFamily: SELECT_FONT }),
        input:      (b: any) => ({ ...b, color: '#fff', fontSize: 16, fontFamily: SELECT_FONT }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (b: any) => ({ ...b, color: 'rgba(255,255,255,0.3)', padding: '0 10px' }),
    }

    return <Modal title="Gerar Relatório" toggleModal={toggle}>
        {/* width 100% + stretch = larguras iguais; maxHeight none + flex-start = modal cresce com o conteúdo */}
        <Body.Content style={{ width: isMobile ? '100%' : 400, alignItems: 'stretch', maxHeight: 'none', justifyContent: 'flex-start' }}>
            <style>{fpInputStyle}</style>

            {/* ── Usina (só aparece se > 1) ── */}
            {usinas.length > 1 && (
                <div style={grCard}>
                    <div style={{ padding: '14px 16px'}}>
                        <div style={microLabel}>Usina</div>
                        <Select<UsinaOpt>
                            options={usinaOptions}
                            value={usinaSelected}
                            onChange={opt => opt && setSelectedToken(opt.value)}
                            styles={selectStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            isSearchable={false}
                        />
                    </div>
                </div>
            )}

            {/* ── Período principal ── */}
            <div style={grCard}>
                <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div style={microLabel}>Período do relatório</div>
                    <div>
                        <div style={{ ...microLabel, fontSize: 9, marginBottom: 4 }}>INÍCIO</div>
                        <div className="gr-fp-wrap">
                            <Flatpickr onChange={([d]) => d && setStartDate(d)} options={inicioFpOpts} placeholder="dd/mm/aaaa" />
                        </div>
                    </div>
                    <div>
                        <div style={{ ...microLabel, fontSize: 9, marginBottom: 4 }}>FIM</div>
                        <div className="gr-fp-wrap">
                            <Flatpickr onChange={([d]) => d && setEndDate(d)} options={fimFpOpts} placeholder="dd/mm/aaaa" />
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Comparação ── */}
            <div style={grCard}>
                {/* Linha do toggle — onClick só no ToggleSwitch, não no div inteiro (evita double-fire) */}
                <div style={{ padding: '13px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ fontFamily: 'Nunito,sans-serif', fontSize: 13, fontWeight: 600, color: comparar ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.5)' }}>
                            Comparar com outro período
                        </div>
                        <div style={{ fontFamily: 'Nunito,sans-serif', fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>
                            Análise lado a lado de dois períodos no relatório
                        </div>
                    </div>
                    <ToggleSwitch isOn={comparar} onToggle={() => setComparar(v => !v)} />
                </div>

                {comparar && (
                    <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <div>
                            <div style={{ ...microLabel, fontSize: 9, marginBottom: 4 }}>INÍCIO DA COMPARAÇÃO</div>
                            <div className="gr-fp-wrap">
                                <Flatpickr onChange={([d]) => d && setCompStartDate(d)} options={compInicioFpOpts} placeholder="dd/mm/aaaa" />
                            </div>
                        </div>
                        <div>
                            <div style={{ ...microLabel, fontSize: 9, marginBottom: 4 }}>FIM DA COMPARAÇÃO</div>
                            <div className="gr-fp-wrap">
                                <Flatpickr onChange={([d]) => d && setCompEndDate(d)} options={compFimFpOpts} placeholder="dd/mm/aaaa" />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* ── E-mail destino ── */}
            <div style={{ display: 'flex', alignSelf: 'center', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <Mail size={14} color="rgba(255,255,255,0.3)" strokeWidth={1.8} />
                <span style={{ fontFamily: 'Nunito,sans-serif', fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
                    Será enviado para{' '}
                    <span style={{ color: email ? '#7BB8E8' : '#F03F3F', fontWeight: 600 }}>
                        {email || 'e-mail não configurado'}
                    </span>
                </span>
            </div>

            {/* ── Botão com gradiente deslizante no hover ── */}
            <button
                onClick={handleGenerate}
                disabled={loading}
                onMouseEnter={() => setBtnHover(true)}
                onMouseLeave={() => setBtnHover(false)}
                style={{
                    width: '100%', padding: '13px 0', borderRadius: 12, border: 'none',
                    background: 'linear-gradient(90deg, #5292D1 0%, #92B258 50%, #5292D1 100%)',
                    backgroundSize: '200% 100%',
                    backgroundPosition: btnHover ? '100% 0' : '0% 0',
                    color: '#fff', cursor: loading ? 'default' : 'pointer',
                    fontFamily: 'Montserrat,sans-serif', fontWeight: 700, fontSize: 14,
                    opacity: loading ? 0.6 : 1,
                    transform: btnHover && !loading ? 'translateY(-1px)' : 'translateY(0)',
                    boxShadow: btnHover && !loading ? '0 6px 20px rgba(82,146,209,0.35)' : 'none',
                    transition: 'background-position 0.4s ease, transform 0.15s ease, box-shadow 0.15s ease, opacity 0.2s',
                }}
            >
                {loading ? 'Gerando...' : 'Gerar e enviar'}
            </button>

        </Body.Content>
    </Modal>
})
